import { useQuery } from '@apollo/client';
import { Feature } from '@shinetools/pricing-plan-library';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { UpgradablePlanBadgeComponentDocument } from './graphql/upgradablePlanBadgeComponent.gql';

export const useUpgradablePlanBadgeComponentQuery = (feature: Feature) => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is undefined in useUpgradablePlanBadgeComponentQuery',
    );
  }

  const { data, ...hook } = useQuery(UpgradablePlanBadgeComponentDocument, {
    skip: !feature,
    variables: {
      companyProfileId,
      feature,
    },
  });

  return {
    planName:
      data?.viewer.company.currentPlan.upgradablePlansWithFeatureAvailable[0]
        ?.brandName,
    ...hook,
  };
};
